import { Injectable } from "@angular/core";
import { DISABLE_ETRACKER_COOKIE_KEY } from "app/common";
import { CookieService } from "ngx-cookie-service";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class EtrackerConsentService {
  private analyticsConsent$ = new BehaviorSubject<boolean>(
    this.cookieService.get(DISABLE_ETRACKER_COOKIE_KEY) === "false"
  );
  analyticsConsentChanges$ = this.analyticsConsent$.asObservable();

  constructor(private cookieService: CookieService) {}

  setConsent(allow: boolean) {
    this.cookieService.set(DISABLE_ETRACKER_COOKIE_KEY, (!allow).toString(), { path: "/", sameSite: "Lax" });
    this.analyticsConsent$.next(allow);
  }
}
